<!-- 月度运行情况 -->
<template>
  <div class="month-chart">
    <div class="chart" ref="chart">
    </div>
    <div style="position: absolute;right: 50px;top: 20px;">
      <el-date-picker v-model="dates" type="daterange"
                      range-separator="至"
                      value-format="yyyy-MM-dd"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      @change="query"></el-date-picker>
      <el-button type="text" style="margin-left: 10px" @click="download">导出</el-button>
    </div>
  </div>
</template>

<script>

import BaseVue from "@/components/base/BaseVue";
import * as echarts from 'echarts';

export default {
  extends: BaseVue,
  components: {},

  props: {
    deviceCode : {
      required: true
    }
  },

  data() {
    return {
      chart: null,
      dates: null,
      option: {
        color: ['#2b85e4', '#19be6b','#ed4014'],
        grid:{
          bottom:30,
          left: 50,
          right: 50,
          top: 100
        },
        title: {
          text: "日运行统计",
          left: "center",
          top: 20
        },
        tooltip: {
          trigger: 'axis',
          formatter: "{b}日：<br/>{a0}运行 : {c0}小时<br/>{a1}运行 : {c1}小时<br/>{a2} : {c2}度",
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['空调', '新风','日耗电量'],
          top: 10,
          left: 10
        },
        toolbox: {
          show: true,
          left: 'right',
          top: 10,
          feature: {
            // mark: {show: true},
            // dataView: {show: true, readOnly: false},
            // magicType: {show: true, type: ['line', 'bar', 'stack', 'tiled']},
            // restore: {show: true},
            saveAsImage: {show: true}
          }
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            axisTick: {show: false},
            data: []//x轴显示文本
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '小时'
          },
          {
            type: 'value',
            name: '度'
          }
        ],
        series: [
          {
            name: '空调',
            type: 'bar',
            barMaxWidth: 30,
            barGap: 0,
            label: {
              show: true
            },
            data: []
          },
          {
            name: '新风',
            type: 'bar',
            barMaxWidth: 30,
            label: {
              show: true
            },
            data: []
          },
          {
            name: '日耗电量',
            type: 'line',
            smooth: true,
            yAxisIndex: 1,
            label: {
              show: true
            },
            data: []
          }
        ]
      }
    }
  },
  created() {
    this.$nextTick(()=>{
      this.chart = echarts.init(this.$refs["chart"]);
      this.chart.setOption(this.option);
    });
    this.query();
  },
  methods: {
    query() {
      this.loading = true;
      this.postForm("/device-day-info/v2/list", {
        deviceCode: this.deviceCode,
        startDate: this.dates ? this.dates[0] : null,
        endDate: this.dates ? this.dates[1] : null,
        page: 1,
        limit: this.dates ? 100 : 40
      }, true).then(dr => {
        this.clear();
        let data = dr.rows || [];
        data.reverse().forEach((d => {
          this.option.xAxis[0].data.push(d.dt);
          this.option.series[0].data.push(((d.acRunMinutes||0)/60).toFixed(1));
          this.option.series[1].data.push(((d.fanRunMinutes||0)/60).toFixed(1));
          this.option.series[2].data.push(d.dayKwh);
        }));
        this.refresh();
      }).finally(()=>{
        this.loading = false;
      });
    },
    //清空数据
    clear: function(){
      this.option.xAxis[0].data = [];
      this.option.series[0].data = [];
      this.option.series[1].data = [];
      this.option.series[2].data = [];
    },
    refresh() {
      this.chart.setOption(this.option);
    },
    download() {
      window.open(this.globalConfig.apiRoot+"/device-day-info/export?deviceCode="+this.deviceCode
          +"&startDate="+(this.dates ? this.dates[0] : "")
          +"&endDate="+(this.dates ? this.dates[1] : "")
      );
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../css/variables";
.month-chart {
  padding: 10px;
  position: relative;
  border: 1px solid $color-border-primary;
  border-radius: 5px;
  margin-bottom: 20px;
  .chart {
    min-height: 400px;
  }
}
</style>
